export const API_DETAILS = {
    URL: 'https://api.airtable.com/v0/appsJDi2s5AKLyf5z/Glossary%20Data',
    KEY: 'keyHsJP9sCMpQ1uhK',
  };
  
  export const CATEGORY_LIST = [
    {label: 'All', value: 'recpR5YrmA7YixItg', selected: true},
    {label: 'Concept', value: 'recBklHCKHNWAfkhN', selected: false},
    {label: 'Equipment', value: 'reczjLTb56z6oQcvq', selected: false},
    {label: 'Reagent', value: 'recmEDZ0UOfHFs6lP', selected: false},
    {label: 'Technique', value: 'recjfi4EEJY556cGg', selected: false},
  ];  
  